import { Pto } from '@outcoreaix/pto'
import { apiSlice } from './api-splice'

export const studentPlanApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStudentPlanSection: builder.query<Pto.StudentPlan.StudentPlanSection, number>({
      query: (spaceId) => ({
        url: `student-plan/section/${spaceId}`,
        method: 'GET'
      }),
      providesTags: ['StudentPlanSection']
    }),
    startArtifactStarter: builder.mutation<{ started: boolean }, { spaceId: number; starterId: number }>({
      query: ({ spaceId, starterId }) => ({
        url: `student-plan/${spaceId}/artifact-starters/${starterId}/start`,
        method: 'PATCH'
      }),
      invalidatesTags: ['StudentPlanSection']
    }),
    completeArtifactStarter: builder.mutation<{ completed: boolean }, { spaceId: number; starterId: number }>({
      query: ({ spaceId, starterId }) => ({
        url: `student-plan/${spaceId}/artifact-starters/${starterId}/complete`,
        method: 'PATCH'
      }),
      invalidatesTags: ['StudentPlanSection']
    })
  })
})

export const { useGetStudentPlanSectionQuery, useStartArtifactStarterMutation, useCompleteArtifactStarterMutation } =
  studentPlanApi
